let modalName
let elFocusFrom

/**
 * Handles opening a specified modal and setting accessibility
 * attributes and additional event listeners
 * @param modal {String}
 * @param clickedElement
 */
const openModal = (modal, clickedElement) => {
    modalName = modal
    elFocusFrom = clickedElement
    const elTargetModal = document.querySelector(`[data-modal="${modalName}"]`)
    const elTargetModalOverlay = elTargetModal.querySelector('[data-overlay]')
    const modalClose = elTargetModal.querySelectorAll('[data-close]')
    const [elCloseX] = modalClose
    const [elFinalAction] = Array.from(elTargetModal.querySelectorAll('.modal__footer *')).reverse()

    // Open the modal
    elTargetModal.setAttribute('data-modal-open', 'true')
    elTargetModal.setAttribute('aria-hidden', 'false')

    // Lock Body Scroll
    document.body.classList.add('-lockScroll')

    // Bind listeners to element and actions that close modal
    modalClose.forEach((elModalClose) => {
        elModalClose.addEventListener('click', () => closeModal(elModalClose.dataset.close || modalName))
    })
    document.addEventListener('keyup', handleEscape)
    elTargetModalOverlay.addEventListener('click', handleClickaway)

    // Delay focus to first link until after visibility is toggled
    setTimeout(() => elCloseX.focus(), 500)

    // Trap focus within modal
    elFinalAction?.addEventListener('keydown', (event) => {
        if (event.keyCode === 9 && !event.shiftKey) {
            // Timeout fixes odd bug where focused element also gets tab input and gets skipped
            setTimeout(() => elCloseX.focus(), 1)
        }
    })
}

/**
 * Handles closing a modal, setting accessibility attributes
 * and returning focus to prior element
 * @param modal {String}
 */
const closeModal = (modal) => {
    const elTargetModal = document.querySelector(`[data-modal="${modal}"]`)
    elTargetModal.setAttribute('data-modal-open', 'false')
    elTargetModal.setAttribute('aria-hidden', 'true')
    document.removeEventListener('keyup', handleEscape)
    document.body.classList.remove('-lockScroll')
    elFocusFrom.focus()
}

/**
 * Closes modal when clicked outside
 */
const handleClickaway = () => closeModal(modalName)

/**
 * Closes modal when esc is pressed
 * @param event
 */
const handleEscape = (event) => {
    if (event.keyCode === 27) closeModal(modalName)
}

export {
    openModal,
    closeModal
}
